import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../services/utelize/general/exceptions-service';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PlatformModeGuard {
  constructor(
    private exceptionsService: ExceptionsService,
    private router           : Router
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    try {
      if (!environment.platformMode)
        return true;

      if (state.url === '/dashboard-main'  || state.url.startsWith('/dashboard-main?')  ||
          state.url === '/dashboard-usage' || state.url.startsWith('/dashboard-usage?'))
        return true;
  
      this.router.navigate(['/platform'], { queryParams: { returnUrl: state.url } });
      
      return false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
}
